import { WeekDay } from '@angular/common';
import { toDate, utcToZonedTime } from 'date-fns-tz';

export function parseDateAsDateInTimezone(input: string | Date, timeZone: string): Date {
    return utcToZonedTime(toDate(input, { timeZone, weekStartsOn: WeekDay.Monday }),
        timeZone, { weekStartsOn: WeekDay.Monday });
}
